export enum EntityTypes {
  ACCOUNT = 'ACCOUNT',
  PROJECT = 'PROJECT',
  USER = 'USER',
  ASSET = 'ASSET',
  FILE = 'FILE',
}
